import { getZrmListingInfo, getZrmRentalsLead, getZrmUserInfo } from '@zg-rentals/clickstream';
import { trackListingEvent } from '../../analytics';
import {
  type ClickstreamEventParams,
  SEMANTIC_EVENT_NAME,
  TOPIC_TAG_TXT,
  TRIGGER_OBJECT,
  TRIGGER_SOURCE,
  TRIGGER_TYPE,
} from './globals';

const EVENT_TEMPLATE_ID = '628';

// https://dataportal.zillowgroup.net/event-registry/9308
export const emitAttachmentWarningModalImpressionEvent = ({
  user,
  listing,
  triggerLocation,
  lead,
}: ClickstreamEventParams) =>
  trackListingEvent({
    envelope: {
      event_type_id: '9308',
      event_type_version_id: '2',
      event_template_id: EVENT_TEMPLATE_ID,
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Impression,
      trigger_location_nm: triggerLocation,
      trigger_source_nm: TRIGGER_SOURCE.ViewAttachmentModal,
      trigger_object_nm: TRIGGER_OBJECT.Attachment,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ViewContent,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    ...getZrmUserInfo(user),
    ...getZrmListingInfo(listing),
    ...getZrmRentalsLead(lead),
  });

// https://dataportal.zillowgroup.net/event-registry/9309
export const emitViewAttachmentButtonClickEvent = ({ user, listing, triggerLocation, lead }: ClickstreamEventParams) =>
  trackListingEvent({
    envelope: {
      event_type_id: '9309',
      event_type_version_id: '2',
      event_template_id: EVENT_TEMPLATE_ID,
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: triggerLocation,
      trigger_source_nm: TRIGGER_SOURCE.ViewAttachmentModal,
      trigger_object_nm: 'view_attachment_button',
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ViewAttachments,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    ...getZrmUserInfo(user),
    ...getZrmListingInfo(listing),
    ...getZrmRentalsLead(lead),
  });
